import styled, { css } from "styled-components";

import { colors } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

import Button from "../Button";
import iconArrowRight from "../../../assets/images/icons/arrow-right-straight.svg";

export interface CellarBtnCtaProps {
  disabled?: boolean;
}

const CellarBtnCta = styled(Button).attrs(() => ({
  full: true,
  lg: true,
  ghost: true,
}))<CellarBtnCtaProps>`
  ${breakpoints.xsUp} {
    font-size: 12px;
  }
  font-weight: normal;
  text-align: left;
  background-image: url("${iconArrowRight}");
  background-repeat: no-repeat;
  background-position: right 15px center;
  background-size: 16px;
  padding: 20px 45px 20px 15px;

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  ${(props) =>
    props.disabled &&
    css`
      &:disabled,
      &:disabled:hover {
        color: ${colors.gray} !important;
        border-color: ${colors.gray};
        background-color: ${colors.transparent};
      }
    `}
`;

export default CellarBtnCta;
